import { render, staticRenderFns } from "./InputBorrow.vue?vue&type=template&id=1e6cc6f8&scoped=true"
import script from "./InputBorrow.vue?vue&type=script&lang=js"
export * from "./InputBorrow.vue?vue&type=script&lang=js"
import style0 from "./InputBorrow.vue?vue&type=style&index=0&id=1e6cc6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6cc6f8",
  null
  
)

export default component.exports